/* eslint-disable no-restricted-properties */
import { createRoot } from 'react-dom/client';

import getMessages from '../i18n';
import { loadContactsStats } from '../contacts';
import initRecoveryPhoneNumberSetup from './recovery-phone-number';

const setupHistoricalStatus = (container) => {
  getMessages().then((i18n) => {
    const periodSelectContainer = document.querySelector('.historical-period');
    const width = Math.floor(container.getBoundingClientRect().width);

    Promise.all([
      import('../contacts/components/contacts-growth-chart'),
      loadContactsStats(),
    ]).then(([{ default: ContactsGrowthChart }, stats]) => {
      const root = createRoot(container);
      root.render(
        <ContactsGrowthChart
          i18n={i18n}
          data={stats}
          width={width}
          periodSelectContainer={periodSelectContainer}
        />
      );
    });
  });
};

/**
 * Set up logic for hiding/showing relevant fields in the custom field form.
 *
 * Based on data type chosen (or not chosen yet) for the custom field, we show/hide and
 * change input type of relevant fields. Eg. if data type is chosen as boolean, there's
 * no longer an option to input a list of valid choices as values since boolean can only
 * have true/false as values.
 *
 * @param {HTMLFormElement} form The form for adding a custom field.
 */
const setupCustomFieldForm = (form) => {
  const dataTypeList = document.getElementById('data_type');
  const choices = document.getElementById('choices-fieldset');
  const choicesFields = Array.from(choices.querySelectorAll('input'));
  const choicesToggle = document.getElementById('is_choices_defined');
  const rules = document.getElementById('rules-fieldset');
  const ruleFields = Array.from(rules.querySelectorAll('.rule'));

  const clearInputs = (fields) => {
    fields.forEach((el) => {
      const input =
        el.tagName.toLowerCase() === 'input' ? el : el.querySelector('input');
      input.value = '';
    });
  };

  const update = () => {
    const dataType = form.data_type.value;
    const choicesToggleField = choicesToggle.closest('.cell');
    rules.classList.toggle(
      'is-hidden',
      !dataType || dataType === 'boolean' || choicesToggle.checked
    );
    choices.classList.toggle(
      'is-hidden',
      !choicesToggle.checked || dataType === 'boolean'
    );
    choicesToggleField
      .closest('.cell')
      .classList.toggle('is-hidden', dataType === 'boolean');

    if (rules.classList.contains('is-hidden')) {
      clearInputs(ruleFields);
    }
    if (choices.classList.contains('is-hidden')) {
      clearInputs(choicesFields);
    }

    if (dataType) {
      ruleFields.forEach((ruleEl) =>
        ruleEl.classList.toggle(
          'is-hidden',
          ruleEl.dataset.types.indexOf(dataType) === -1
        )
      );

      if (dataType !== 'boolean') {
        choicesFields.forEach((choiceEl) => choiceEl.setAttribute('type', dataType));
      } else {
        choicesToggle.checked = false;
      }
    }
  };

  choicesToggle.addEventListener('change', () => update());
  dataTypeList.addEventListener('change', () => update());
  update();
};

const initAccounts = () => {
  const historicalStatusContainer = document.getElementById(
    'historical-contacts-container'
  );
  const addCustomFieldForm = document.getElementById('add-custom-field');

  const recoveryPhoneNumberContainer = document.getElementById(
    'recovery-phone-container'
  );

  if (historicalStatusContainer) {
    setupHistoricalStatus(historicalStatusContainer);
  }

  if (addCustomFieldForm) {
    setupCustomFieldForm(addCustomFieldForm);
  }

  if (recoveryPhoneNumberContainer) {
    const phone = recoveryPhoneNumberContainer.getAttribute('data-phone');
    initRecoveryPhoneNumberSetup(recoveryPhoneNumberContainer, phone);
  }
};

export default initAccounts;
